
export default {
	init() {
		let $posts = $( '.post-cards--grid-inner li' )
		let $loadMore = $( '.sga--load-more' )
		let count = 1
		let postsPerPage = 6
		let pages = Math.ceil( $posts.length / postsPerPage )
		$posts.slice(postsPerPage*count, $posts.length).hide()
		$loadMore.on( 'click', function() {
			$posts.slice(postsPerPage*count, postsPerPage*(count+1)).map((idx, el) => {
				console.log(idx*0.3)
				setTimeout(function() {
					 $(el).fadeIn()
				}, idx*50)
			})
			$posts.slice(postsPerPage*count, postsPerPage*(count+1))
			count++
			if ( count >= pages ) {
				$loadMore.hide()
			}
		})
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
